(function($){
  function findColor(list) {
    var e = ["white", "gray", "grey", "black", "brown", "green", "blue", "purple", "pink", "red", "orange", "yellow", "natural"];
    return $.inArray(list, e) > -1
  }

  if ($(".product-tags").length) {
    $(".product-tags").find("ul li").each(function() {
      var $this = $(this);
      return findColor($this.data("name")) ? ($(".product__color .value").text($this.text()), !1) : void 0
    })
  }

  if ($(".product__description").length) {
    var sizeInfo = $(".product__description #product-size-info").detach();
    var materialsInfo = $(".product__description #product-materials-info").detach();
    var careInfo = $(".product__description #product-care-info").detach();
    $(".product-measurement").append(sizeInfo); 
    $(".product-materials").append(materialsInfo); 
    $(".product-care").append(careInfo); 
  }
}(jQuery));